const getSkuQueryStringForFullBundle = (skus: string[]) =>
  skus.reduce((queryString, sku) => `${queryString}&sku=${sku}`, "");

export default getSkuQueryStringForFullBundle;
